import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-redemption-chart',
  templateUrl: './flight-redemption-chart.component.html',
  styleUrls: ['./flight-redemption-chart.component.scss']
})
export class FlightRedemptionChartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
